import moment from 'moment-timezone'

import { hoursToObject, formatHoursForAPI } from '../IntegrationModal/helpers'

const userTz = moment.tz.guess()

export type BaseInboxEditType = BaseInboxUpdate & { id?: string }

export const INITIAL_VALUES: BaseInboxEditType = {
  name: '',
  hours: [],
  timezone: userTz ?? null,
  online_profile: 'follow_schedule',
  user_override: false,
  team_restrict: [],
  all_teams: false,
  archived: null
}

// Tries to format the inbox from the api into a usable format
export const formatDataFromAPI = (data: APIBaseInbox) => {
  const result: BaseInboxEditType = {
    ...INITIAL_VALUES,
    ...data,
    hours: hoursToObject(data.hours),
    team_restrict: data.team_restrict ?? [],
    user_override: data.user_override ?? false,
    all_teams: data.user_override ?? false ? false : data.all_teams ?? false,
    timezone: data.timezone ?? userTz
  }
  return result
}

// Re-formats data for upload
export const formatPayload = (values: BaseInboxEditType) => {
  if (!values.name.length) {
    return { error: 'Please enter a name' }
  }

  const all_teams = values.all_teams ?? false
  let team_restrict = values.team_restrict
  if (all_teams || team_restrict.length === 0) {
    team_restrict = null
  }

  const data: BaseInboxUpdate = {
    name: values.name,
    hours: formatHoursForAPI(values.hours),
    timezone: values.timezone,
    online_profile: values.online_profile,
    user_override: values.user_override ?? false,
    team_restrict,
    all_teams,
    archived: values.archived
  }

  return { data }
}

export const PROFILE_OPTIONS = {
  always_online: 'Always online (not recommended)',
  follow_schedule: 'Follow schedule',
  always_offline: 'Always offline (to disable)'
}
